import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";


export default function Newsadmin() {
  const [headline, setHeadline] = useState("");
  const [details, setDetails] = useState("");
  const [newsDate, setNewsDate] = useState("");
  const [image, setImage] = useState(null);
  const [news, setNews] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  // LOAD
  const loadNews = async () => {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/allnews.php");
    const data = await res.json();
    setNews(data);
  };

  useEffect(() => {
    loadNews();
  }, []);

  // SELECT
  const handleSelect = (n) => {
    setSelectedId(n.id);
    setHeadline(n.headline);
    setDetails(n.details);
    setNewsDate(n.news_date);
  };

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("headline", headline);
    formData.append("details", details);
    formData.append("news_date", newsDate);
    formData.append("image", image);

    let url = "https://drpatangecitydentalclinic.com/api/addnews.php";

    if (selectedId) {
      formData.append("id", selectedId);
      url = "https://drpatangecitydentalclinic.com/api/news_update.php";
    }

    await fetch(url, {
      method: "POST",
      body: formData,
    });

    setHeadline("");
    setDetails("");
    setNewsDate("");
    setImage(null);
    setSelectedId(null);

    loadNews();
  };

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this news?")) return;

    const formData = new FormData();
    formData.append("id", id);

    await fetch("https://drpatangecitydentalclinic.com/api/deletenews.php", {
      method: "POST",
      body: formData,
    });

    loadNews();
  };

  return (
    <div className="container-fluid p-4">

        <div className="row">
        <div className="col-md-3 col-lg-2 p-0">
          <Sidebar />
        </div>

        
        <div className="col-md-9 col-sm-12 col-lg-10 p-4">

      <h2 className="mb-4">News Management</h2>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="card p-3 mb-4 shadow">

        <input
          className="form-control mb-2"
          placeholder="Headline"
          value={headline}
          onChange={(e) => setHeadline(e.target.value)}
          required
        />

        <textarea
          className="form-control mb-2"
          placeholder="Details"
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          required
        />

        <input
          type="date"
          className="form-control mb-2"
          value={newsDate}
          onChange={(e) => setNewsDate(e.target.value)}
          required
        />

        <input
          type="file"
          className="form-control mb-2"
          onChange={(e) => setImage(e.target.files[0])}
          required={!selectedId}
        />

        <button className="btn btn-primary w-100">
          {selectedId ? "Update News" : "Add News"}
        </button>

      </form>

      {/* TABLE */}
<div className="table-responsive">

  <table className="table table-bordered table-hover align-middle">

    <thead className="table-dark">
      <tr>
        <th style={{ minWidth: "60px" }}>ID</th>
        <th style={{ minWidth: "200px" }}>Headline</th>
        <th style={{ minWidth: "200px" }}>Details</th>
        <th style={{ minWidth: "120px" }}>Date</th>
        <th style={{ minWidth: "90px" }}>Image</th>
        <th style={{ minWidth: "160px" }}>Actions</th>
      </tr>
    </thead>

    <tbody>
      {news.map((n) => (
        <tr key={n.id}>

          <td>{n.id}</td>

         
          <td>
            <div style={{ maxWidth: "250px", whiteSpace: "normal" }}>
              {n.headline}
            </div>
          </td>

                    <td>
            <div style={{ maxWidth: "250px", whiteSpace: "normal" }}>
              {n.details}
            </div>
          </td>

          <td>{n.news_date}</td>

           <td>
            <img
              src={n.image}
              alt=""
              style={{
                width: "60px",
                height: "60px",
                objectFit: "cover",
                borderRadius: "6px"
              }}
            />
          </td>


          <td>
            <div className="d-flex flex-wrap gap-2">

              <button
                className="btn btn-primary btn-sm"
                onClick={() => handleSelect(n)}
              >
                Select
              </button>

              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleDelete(n.id)}
              >
                Delete
              </button>

            </div>
          </td>

        </tr>
      ))}
    </tbody>

  </table>

</div>
</div>
      </div>

    </div>
  );
}